const ITEMS = [
  "QUANTUM COMPUTING",
  "DECENTRALIZED ENERGY",
  "FUSION DYNAMICS",
  "NEURAL ARCHITECTURES",
  "BIOTECH GENOMICS",
  "OPEN SOURCE HARDWARE",
];

export default function Marquee() {
  return (
    <div className="border-y border-[#1E2638] bg-[#0F131C] py-4 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0">
            {ITEMS.map((t) => (
              <span key={`${copy}-${t}`} className="mx-10 font-mono text-xs tracking-[0.35em] text-slate-500 flex items-center gap-10">
                {t}
                <span className="text-sky-400">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
